/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// REACT ///
import { useState } from "react";
/// ACTIONS ///
import { updateShopQuoteLineItem } from "api/actions/shop_quote/quote_line_item/api/update";
/// TYPES ///
import { LineItemError } from "api/error_types/line_item_error";
import { IShopQuoteLineItem } from "api/types/shop_quote/quote_line_item";
/// MUI COMPONENTS ///
import Box from "@mui/material/Box";
import { Dialog } from "@mui/material";
import { DialogActions } from "@mui/material";
import { DialogContent } from "@mui/material";
import { DialogTitle } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
/// COMPONENTS ///
import BaseButton from "components/universal/button/base";
/// ICONS ///
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
/// STYLES ///
import { dialog_body_style } from "styles/dialog";

interface Props {
  open: boolean,
  setOpen: (open: boolean) => void,
  item: IShopQuoteLineItem,
  setItem: (item: IShopQuoteLineItem) => void
}

export default function UpdateShopQuoteLineItem({ open, setOpen, item, setItem }: Props) {
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<LineItemError>({});

  const setTaxable = (taxable: string) => {
    if (taxable === "Yes") {
      setItem({ ...item, taxable: true });
    }
    else {
      setItem({ ...item, taxable: false });
    }
  }

  const setSecondTaxable = (taxable: string) => {
    if(taxable === "Yes"){
      setItem({...item, second_taxable: true});
    }
    else{
      setItem({...item, second_taxable: false});
    }
  }

  const save = () => {
    let e: LineItemError = {};

    if (!item.price) {
      e.price_error = "Price must be a valid number.";
      e.price_has_error = true;
    }

    if (!item.name || item.name === "") {
      e.name_error = "Must enter a name for this product.";
      e.name_has_error = true;
    }

    setErrors(e);

    if (e.price_has_error || e.name_has_error) {
      return;
    }

    dispatch(updateShopQuoteLineItem(item, item.id));
    setItem({});
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Update Line Item</DialogTitle>
      <DialogContent sx={dialog_body_style}>
        <Box display="flex" flexDirection="column" sx={{ gap: "10px", paddingTop: "10px" }}>
          <TextField
            label="Name"
            value={item?.name ?? ""}
            error={errors.name_has_error}
            helperText={errors.name_error}
            onChange={(e) => setItem({ ...item, name: e.target.value })} />
          <TextField
            type="number"
            label="Price($)"
            error={errors.price_has_error}
            helperText={errors.price_error}
            value={item?.price > 0 ? item.price : ""}
            onChange={(e) => setItem({ ...item, price: Number(e.target.value) })} />
          <TextField
            type="number"
            label="Quantity"
            value={item?.quantity > 0 ? item.quantity : ""}
            onChange={(e) => setItem({ ...item, quantity: Number(e.target.value) })} />
          <TextField
            select
            label="Taxable"
            value={item?.taxable ? "Yes" : "No"}
            onChange={(e) => setTaxable(e.target.value)}>
            <MenuItem key="Yes" value="Yes">Yes</MenuItem>
            <MenuItem key="No" value="No">No</MenuItem>
          </TextField>
          <TextField
            select
            label="Apply Second Tax?"
            value={item?.second_taxable ? "Yes" : "No"}
            onChange={(e) => setSecondTaxable(e.target.value)}>
            <MenuItem key="Yes" value="Yes">Yes</MenuItem>
            <MenuItem key="No" value="No">No</MenuItem>
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <BaseButton text="Cancel" icon={faTimes} clickEvent={() => setOpen(false)} />
        <BaseButton text="Save" icon={faPlus} clickEvent={save} />
      </DialogActions>
    </Dialog>
  )
}
